module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei5.svg";